module.exports = __webpack_public_path__ + "media/images/Endecott-Display-1-55b582df77ca54dde0f461582b6b4682.jpg";